import React, { useState, useEffect } from 'react';
import './Cases.css';
import case1 from '../marketplaceassets/case1.png';
import case2 from '../marketplaceassets/case2.png';
import case3 from '../marketplaceassets/case3.png';
import case4 from '../marketplaceassets/case4.png';
import case5 from '../marketplaceassets/case5.png';
import case6 from '../marketplaceassets/case6.png';
import case7 from '../marketplaceassets/case7.png';
import case8 from '../marketplaceassets/case8.png';

export default function Cases() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [cardsToShow, setCardsToShow] = useState(3);

  const cases = [
    { img: case1, name: 'On-chain credentials' },
    { img: case2, name: 'Tokenized access NFTs' },
    { img: case3, name: 'Supply chain NFTs' },
    { img: case4, name: 'Digital identity NFTs' },
    { img: case5, name: 'Dynamic AI NFTs' },
    { img: case6, name: 'Legal contract NFTs' },
    { img: case7, name: 'Fractional ownership NFTs' },
    { img: case8, name: 'Enterprise utility NFTs' }
  ];

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setCardsToShow(3);
      } else {
        setCardsToShow(2);
      }
      setCurrentSlide(0);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div id='marketplace-cases' className='marketmainclass'>
      <h2 className="heading">
        Leading use cases for NFT marketplace development 
      </h2>
      <p className="subheading">
      From digital assets to enterprise solutions, NFT marketplaces unlock new ways to create and exchange value.
      </p>
      
      <div className="cards">
        {cases.map((item, index) => (
          <div className="card" key={index}>
            <img src={item.img} alt="error" />
            <span>{item.name}</span>
          </div>
        ))}
      </div>

     <div className="carousel-container">
       
        <div className="carousel-wrapper">
          <div 
            className="carousel-track"
           style={{
  transform: `translateX(-${currentSlide * 100}%)`
}}
          >
            {Array.from({ length: Math.ceil(cases.length / cardsToShow) }).map((_, slideIndex) => (
              <div className="carousel-slide" key={slideIndex}>
                {cases
                  .slice(slideIndex * cardsToShow, (slideIndex + 1) * cardsToShow)
                  .map((item, index) => (
                    <div className="card" key={index}>
                      <img src={item.img} alt="error" />
                      <span>{item.name}</span>
                    </div>
                  ))}
              </div>
            ))}
          </div>
        </div>

        <div className="carousel-dots">
          {Array.from({ length: Math.ceil(cases.length / cardsToShow) }).map((_, index) => (
            <button
              key={index}
              className={`dot ${currentSlide === index ? 'active' : ''}`}
              onClick={() => setCurrentSlide(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}